import {CompanyConfig} from '../types';
import {baseRoles, mergeWithDefaults} from './base.config';

const {labels, features, roles} = mergeWithDefaults(
  {
    order: 'Job',
    orders: 'Jobs',
    customer: 'Tenant',
    customers: 'Tenants',
    dispatch: 'Job Assignment',
    payment: 'Money In',
    deliveries: 'Jobs',
  },
  {
    hasOfferingTypeFilterOnOrders: true,
    hasServiceOnOrderCreation: true,
    hasJobDescriptionOnOrderCreation: true,
    hasPropertyDetailsOnOrderDetails: true,
    hasMoneyInOnOrderDetails: true,
    hasServicesOnOrderDetails: true,
    hasPayerTypeOnCharge: true,
    hasManagedPropertiesOnCompanyDetails: true,
    hasServicesOnOffering: true,
    hasLandlordFilterOnCustomers: true,
    hasPropertyFilterOnCustomers: true,
    hasJobDescriptionOnOrderDetails: true,
    hasCostAndProfitOnOrderDetails: true,
    hasMergeOrdersOnOrderList: true,
  },
  [
    ...baseRoles,
    {
      value: 'landlord',
      label: 'Landlord',
      description: 'manage properties, tenants and jobs',
    },
  ]
);

export const propertyManagerConfig: CompanyConfig = {
  type: 'property_manager',
  labels,
  features,
  roles,
};
